import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Modal } from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import UploadFolderHeader from "./UploadFolderHeader";
import UploadFolderBody from "./UploadFolderBody";
import UploadFolderFooter from "./UploadFolderFooter";
import moment from "moment";
// import BunkeyMultiUploadTour from "../tour/BunkeyMultiUploadTour";
import AWS from "../../utils/aws-config.js";
import UploadFile from "../../utils/UploadFile";
import { createNestedStructure, getFileType } from "./UploadFolderUtils";
import {
  updateRootFolder,
  updateMetadata,
  addFileToSave,
  saveFolderStructure,
  sendNotificationsaveFolder
} from "../../actions/UploadFolderAction";
import {
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps,
  updateMetadataClient
} from "../../actions/ClientAction";
import "./UploadFolderMoldal.css";
import { getExplore } from "../../actions/AssetsExploreAction";
import { cleanDataBackRoot, getRoot } from "../../actions/AssetsRootAction";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import { sendNotification, refrescarHastaQueCrezca } from "../../utils";
import store from "../../store";
import { sendShareAssetsUpload } from "../../actions/AssetsShareAction";
import { RIGHTS_STATUS_UNASSIGNED } from "../../constants/rights-constants";
import BunkeyAPI from '../../api/BunkeyAPI'
class UploadFolderModal extends Component {
  constructor(props) {
    super(props);
    AWS.config.setPromisesDependency();
    
    this.state = {
      start: false
    };
  }

  // Reintentos de refresco en vuelo, para cortarlos si se desmonta el modal.
  cancelarRefresco = null;

  componentWillUnmount() {
    if (this.cancelarRefresco) this.cancelarRefresco();
  }

  // Refresca la vista donde esta parado el usuario. El backend puede tardar en
  // crear los objetos, asi que reintenta con espera creciente hasta que el
  // conteo crezca, y se corta si el usuario se fue a otra carpeta.
  refrescarVistaActual = (workclient, root) => {
    const carpetaActual = () => this.props.location.pathname.split("/").pop();
    const exploreId = carpetaActual();
    const enRaiz = exploreId === "home";

    if (enRaiz) {
      this.props.cleanDataBackRoot();
      this.props.getLastUploads(workclient, root);
    }

    if (this.cancelarRefresco) this.cancelarRefresco();
    this.cancelarRefresco = refrescarHastaQueCrezca(
      () =>
        enRaiz
          ? this.props.getRoot(workclient, root, true, [], 1, 40)
          : this.props.getExplore(
              workclient,
              exploreId,
              1,
              undefined,
              undefined,
              undefined,
              20
            ),
      () => {
        const slice = enRaiz
          ? store.getState().assetsRoot
          : store.getState().assetsExplore;
        return ((slice && slice.data) || []).length;
      },
      () => carpetaActual() !== exploreId
    );
  };

  componentDidMount() {
    this.props.updateMetadata({
      fileList: [],
      fileListToSave: [],
      rootFolder: [],
      tags: [],
      usageRights: true,
      rightsStatus: RIGHTS_STATUS_UNASSIGNED,
      rightsUiState: "unassigned",
      usersEmails: [],
      tagsProtocol: "",
      route: "/",
      currentStep: 0,
      start: false,
      saveFolderStructureLoading: false,
      saveFolderStructureError: false,
      showUploadFolderModal: false,
      folderselect: "",
      folderList: [],
      dateFrom: null,
      dateFromFormatted: null,
      dateTo: null,
      dateToFormatted: null
      // dateFrom: moment(),
      // dateFromFormatted: moment().format("YYYY/MM/DD"),
      // dateTo: moment(),
      // dateToFormatted: moment().format("YYYY/MM/DD")
    });
  }

  componentDidUpdate(prevProps) {
    const { fileList: fileListOld, start: startOld } = prevProps.uploadFolder;

    const {
      fileList: newFileList,
      start: startNew,
      usersEmails,
      showUploadFolderModal,
      currentStep,
      retryOnlyFile,
      abortOnlyFile,
      removeOnlyFile,
      fileIdsNotification,
      folderselect
    } = this.props.uploadFolder;
    const { intl, user, start, workclient, root } = this.props;
    if (retryOnlyFile && retryOnlyFile.status) {
      this.handleOnlyFileRetry(retryOnlyFile.file);
      this.props.updateMetadata({
        retryOnlyFile: {
          status: false,
          file: null
        }
      });
      this.props.updateMetadataClient({
        isUploading: true
      });
      return;
    }
    if (abortOnlyFile && abortOnlyFile.status) {
      this.handleAbort(abortOnlyFile.file);
      this.props.updateMetadata({
        abortOnlyFile: {
          status: false,
          file: null
        }
      });
      return;
    }
    if (removeOnlyFile && removeOnlyFile.status) {
      this.handleRemoveFile(removeOnlyFile.file);
      this.props.updateMetadata({
        removeOnlyFile: {
          status: false,
          file: null
        }
      });
      return;
    }

    if (prevProps.showUploadFolderModal && !this.props.showUploadFolderModal) {
      if (!start) {
        this.props.updateMetadata({
          fileList: [],
          fileListToSave: [],
          rootFolder: [],
          tags: [],
          dateFrom: null,
          dateFromFormatted: null,
          dateTo: null,
          dateToFormatted: null,
          usageRights: true,
          rightsStatus: RIGHTS_STATUS_UNASSIGNED,
          rightsUiState: "unassigned",
          usersEmails: [],
          tagsProtocol: "",
          route: "/",
          currentStep: 0,
          start: false,
          saveFolderStructureLoading: false,
          saveFolderStructureError: false,
          showUploadFolderModal: false,
          folderselect: "",
          folderList: []
        });
        this.props.updateMetadataClient({
          isUploading: false
        });
      }
    }

    if (fileListOld !== newFileList) {
      this.props.updateRootFolder(createNestedStructure(newFileList, user._id));
    }

    if (
      newFileList.length === 0 &&
      showUploadFolderModal &&
      currentStep === 3
    ) {
      this.props.updateMetadata({
        currentStep: 0
      });
    }

    if (startOld !== startNew && startNew) {
      this.handleUploadFiles();
    }

    if (newFileList && newFileList.length > 0 && start) {
      const contSuccess = newFileList.filter(file => file.state === "success")
        .length;
      const contError = newFileList.filter(file => file.state === "error")
        .length;
      if (contSuccess === newFileList.length) {
        if (usersEmails && usersEmails.length !== 0) {
          this.props.sendShareAssetsUpload(
            workclient,
            user,
            fileIdsNotification,
            "",
            "",
            usersEmails,
            intl,
            10
          );
          this.props.updateMetadata({
            fileIdsNotification: []
          });
          sendNotification(
            "success",
            intl,
            intl.formatMessage({ id: "uploaded_correctly" })
          );
        }
        this.props.updateMetadata({
          fileList: [],
          fileListToSave: [],
          rootFolder: [],
          tags: [],
          dateFrom: null,
          dateFromFormatted: null,
          dateTo: null,
          dateToFormatted: null,
          usageRights: true,
          rightsStatus: RIGHTS_STATUS_UNASSIGNED,
          rightsUiState: "unassigned",
          usersEmails: [],
          tagsProtocol: "",
          route: "/",
          currentStep: 0,
          start: false,
          saveFolderStructureLoading: false,
          saveFolderStructureError: false,
          showUploadFolderModal: false,
          folderselect: "",
          folderList: []
        });
        this.props.updateMetadataClient({
          isUploading: false
        });
        // `readFolder` es lo que crea los objetos en el backend, y antes se
        // disparaba sin esperarlo: el refresco salia 500ms despues y encontraba
        // la carpeta vacia. Ahora lo encadenamos y reintentamos hasta que
        // aparezcan las piezas.
        const creacion = folderselect
          ? this.convertionFolder(folderselect)
          : Promise.resolve();
        creacion.then(() => this.refrescarVistaActual(workclient, root));

        setTimeout(() => {
          if (!usersEmails || usersEmails.length === 0) {
            sendNotification(
              "success",
              intl,
              intl.formatMessage({ id: "uploaded_correctly" })
            );
          }
        }, 500);
      }
      if (contError > 0 && contError + contSuccess === newFileList.length) {
        this.props.updateMetadata({
          start: false
        });
        this.props.updateMetadataClient({
          isUploading: false
        });
      }
    }
  }

  convertionFolder = id => {
    // Devolvemos la promesa: el refresco de la grilla se encadena a esta
    // llamada, que es la que crea los objetos en el backend.
    return BunkeyAPI({
      url: `/convertinators/readFolder`,
      method: "POST",
      data: { id }
    })
      .then(resp => {
        if (resp.status === 201)
          console.log('OK!');
        else
          console.log('Err'); 
      })
      .catch(e => {
        console.log("err: ", e);
      });
  };

  //DEEP 3 - Para cancelar la subida
  handleAbort(asset) {
    asset.uploadObject.abort();
  }

  //DEEP 3 - Para borrar el asset
  handleRemoveFile = asset => {
    const fileList = this.props.uploadFolder.fileList;
    const newList = fileList.filter(e => e.uuid !== asset.uuid);
    this.props.updateMetadata({
      fileList: newList
    });
  };

  //DEEP 3
  handleRetry(asset, massive = null) {
    const { qtyFilesError, numberAttemps, uploadFolder } = this.props;
    this.props.updateMetadata({
      fileList: uploadFolder.fileList.map(r => {
        return {
          ...r,
          state: r.uuid === asset.uuid ? "waiting" : r.state,
          progress: r.uuid === asset.uuid ? 0 : r.progress
        };
      })
    });
    this.handleUploadFiles();
    if (!massive && qtyFilesError > 0) {
      this.props.setQtyFilesError(qtyFilesError - 1);
      this.props.setNumberAttemps(numberAttemps + 1);
    }
    //TODO: Terminar
    // this.props.handleUserAttemps(this.handleAttemps([asset], false))
  }
  handleOnlyFileRetry(asset, massive = null) {
    const { clientId, user, clientName, uploadFolder } = this.props;
    this.props.updateMetadata({
      fileList: uploadFolder.fileList.map(r => {
        return {
          ...r,
          state: r.uuid === asset.uuid ? "inprogress" : r.state,
          progress: r.uuid === asset.uuid ? 0 : r.progress
        };
      })
    });
    const uploadObject = new UploadFile(clientId, clientName, user);
    uploadObject
      .checkIsSetAccelerateConfiguration()
      .then(() => {
        uploadObject.startUpload(
          asset,
          this.setUploadObject,
          this.setFileProgress,
          this.handleSaveRecord,
          this.setFileError
        );
      })
      .catch(error => {
        console.error("error catch ", error);
      });
    //TODO: Terminar
    // this.props.handleUserAttemps(this.handleAttemps([asset], false))
  }
  //FINISH
  handleIsDone = () => {
    const fileList = this.props.uploadFolder.fileList;
    const total = fileList.length;
    const error = fileList.filter(r => r.state === "error").length;

    if (error === 0 || total === 0) {
      //Finalizar proceso de subida
      // this.props.isDone(false, false);
      return;
    }
  };

  //DEEP 2
  setUploadObject = (file, upload) => {
    const fileList = this.props.uploadFolder.fileList;
    this.props.updateMetadata({
      fileList: fileList.map(r => {
        return {
          ...r,
          uploadObject: r.uuid === file.uuid ? upload : r.uploadObject
        };
      })
    });
  };

  //DEEP 2 - Para mostrar la barra
  setFileProgress = (file, e) => {
    const fileList = this.props.uploadFolder.fileList;
    this.props.updateMetadata({
      fileList: fileList.map(r => {
        return {
          ...r,
          state: r.uuid === file.uuid ? "inprogress" : r.state,
          progress:
            r.uuid === file.uuid ? (e.loaded / e.total) * 100 : r.progress
        };
      })
    });
  };

  //DEEP 2 - Cuando el archivo se sube Ok
  handleSaveRecord = asset => {
    const { user, clientId, intl } = this.props;
    const {
      folderselect,
      tags,
      dateFromFormatted,
      dateToFormatted,
      rightsStatus,
      licenseFile,
      licenseFileName,
      usersEmails,
      uuid_session
    } = this.props.uploadFolder;
    const useRightsActive = (this.props.modules || []).some(
      module => module.name === "useRights" && module.activate
    );
    // Viaja también sin el módulo (DES-216): la versión simple escribe los
    // mismos campos, para que si la cuenta activa el módulo después el
    // archivo aparezca con su período y no como "Pendiente". El contrato sí
    // es sólo del módulo.
    const uploadRightsStatus = rightsStatus || null;
    const copyrightDateFrom = dateFromFormatted
      ? dateFromFormatted
      : moment().format("YYYY-MM-DD");
    const fileToSave = {
      id_asset: "file",
      name: asset.name,
      nameBack: asset.nameBack,
      path: asset.path,
      readOnly: true,
      uuid: asset.uuid,
      type: getFileType(asset.ext[0]),
      fileSize: asset.size,
      fileSizeFormat: asset.sizeFormat,
      originalURL: asset.futureFileURL,
      user: user._id,
      metadata: {
        copyRight: "free",
        type: "final",
        createdDate: copyrightDateFrom,
        ...(uploadRightsStatus ? { rightsStatus: uploadRightsStatus } : {}),
        dueDate: dateToFormatted || null,
        ...(useRightsActive && licenseFile
          ? { licenseFile, licenseFileName: licenseFileName || null }
          : {})
      }
    };
    this.props.addFileToSave(fileToSave);
    const newSchema = createNestedStructure([fileToSave], user._id);
    this.props.saveFolderStructure(
      clientId,
      newSchema,
      tags,
      intl,
      folderselect,
      copyrightDateFrom,
      dateToFormatted,
      usersEmails,
      uuid_session,
      fileToSave,
      uploadRightsStatus,
      useRightsActive ? licenseFile : null,
      useRightsActive ? licenseFileName : null
    );
    // this.setFileSuccess(fileToSave);
    return true;
  };

  //DEEP 2 - cuando la subida del archivo genera error
  setFileError = file => {
    const fileList = this.props.uploadFolder.fileList;
    const newList = fileList.map(r => {
      return {
        ...r,
        state: r.uuid === file.uuid ? "error" : r.state
      };
    });
    this.props.updateMetadata({
      fileList: newList
    });
    this.props.setQtyFilesError(
      newList.filter(f => f.state === "error").length
    );
    // this.handleUploadFiles()
  };
  //DEEP 3 - cuando la subida del archivo esta OK - state
  setFileSuccess = file => {
    const fileList = this.props.uploadFolder.fileList;
    const newList = fileList.map(r => {
      return {
        ...r,
        state: r.uuid === file.uuid ? "success" : r.state
      };
    });
    this.props.updateMetadata({
      fileList: newList
    });
  };
  //DEEP 1
  handleUploadFiles = () => {
    const { clientId, user, clientName } = this.props;
    const fileList = this.props.uploadFolder.fileList;
    const inProgress = fileList.filter(r => r.state === "inprogress").length;
    // const LIMIT = 100

    if (inProgress === 0) {
      // fileList.filter(r => (r.state === 'waiting' || r.state === 'error')).slice(0, LIMIT).forEach(file => {
      fileList
        .filter(r => r.state === "waiting" || r.state === "error")
        .forEach(file => {
          if (file.state === "error") {
            file.state = "inprogress";
            file.progress = 0;
          }
          const uploadObject = new UploadFile(clientId, clientName, user);
          uploadObject
            .checkIsSetAccelerateConfiguration()
            .then(() => {
              uploadObject.startUpload(
                file,
                this.setUploadObject,
                this.setFileProgress,
                this.handleSaveRecord,
                this.setFileError
              );
            })
            .catch(error => {
              console.error("error catch ", error);
            });
        });
    }
  };

  render() {
    const { showUploadFolderModal } = this.props;
    const { currentStep, start, uploadFolder } = this.props;
    return (
      <Modal
        visible={showUploadFolderModal}
        onCancel={() => {
          this.props.updateMetadata({
            showUploadFolderModal: false
          });
          if (!start && uploadFolder && uploadFolder.fileList && uploadFolder.fileList.length > 0) {
            const files = uploadFolder.fileList;
            const filesSuccess = files.filter(file => file.state === "success").length;
            const filesWaiting = files.filter(file => file.state === "waiting").length;
            if (filesWaiting === 0 && filesSuccess >= 1 && uploadFolder.folderselect) {
              this.convertionFolder(uploadFolder.folderselect);
            }
          }
        }}
        footer={null}
        closeIcon={
          <img
            src={CloseIcon}
            alt={"icon close"}
            style={{ width: 25, height: 25 }}
          />
        }
        className="modal-parent modal-pay"
        scrollableBody={true}
        destroyOnClose
        centered
      >
        <UploadFolderHeader currentStep={currentStep} />
        <UploadFolderBody currentStep={currentStep} />
        <UploadFolderFooter />
        {/* <BunkeyMultiUploadTour/> */}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentStep: state.uploadFolder.currentStep,
    start: state.uploadFolder.start,
    user: state.authUser.user,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    uploadFolder: state.uploadFolder,
    fileListToSave: state.uploadFolder.fileListToSave,
    qtyFilesError: state.client.qtyFilesError,
    attemps: state.client.attemps,
    numberAttemps: state.client.numberAttemps,
    isUploading: state.client.isUploading,
    workclient: state.client.workclient,
    root: state.client.root,
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  updateMetadata,
  updateRootFolder,
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps,
  addFileToSave,
  saveFolderStructure,
  sendNotificationsaveFolder,
  getLastUploads,
  getRoot,
  cleanDataBackRoot,
  getExplore,
  updateMetadataClient,
  sendShareAssetsUpload
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderModal))
);
